import { render, staticRenderFns } from "./proser.vue?vue&type=template&id=552e6e97&scoped=true&"
import script from "./proser.vue?vue&type=script&lang=js&"
export * from "./proser.vue?vue&type=script&lang=js&"
import style0 from "./proser.vue?vue&type=style&index=0&id=552e6e97&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e6e97",
  null
  
)

export default component.exports